import styled from 'styled-components';

export const Root = styled.div<{ $variant: 'dark' | 'light' }>`
  color: ${(props) =>
    props.$variant === 'dark' ? props.theme.basePalette.greyscale['30'] : props.theme.basePalette.greyscale['70']};
  font-size: 11px; /* Not in our theme */
  text-align: center;
`;
